
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5XrRK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "EmptySkeleton", () => $1f7e6cc6bb050ade$export$fb85bbdbfb3e6869);
$parcel$export(module.exports, "GinRedirect", () => $1f7e6cc6bb050ade$export$3b4f172f4310bbc);
$parcel$export(module.exports, "GinRedirectEntryPoint", () => $1f7e6cc6bb050ade$export$259dd4583d348d86);
$parcel$export(module.exports, "default", () => $1f7e6cc6bb050ade$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1kQCU = parcelRequire("1kQCU");

var $VILOn = parcelRequire("VILOn");

var $7SHTM = parcelRequire("7SHTM");

var $1gXMV = parcelRequire("1gXMV");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $frBVt = parcelRequire("frBVt");

var $4R6GH = parcelRequire("4R6GH");

var $7iJwP = parcelRequire("7iJwP");
const $1f7e6cc6bb050ade$export$fb85bbdbfb3e6869 = ()=>null;
const $1f7e6cc6bb050ade$var$GlobalIssueNavigatorEntryPointContainer = /*#__PURE__*/ (0, $5uXOq.memo)(({ entryPointReference: entryPointReference, nativeIssueTableEntryPoint: nativeIssueTableEntryPoint })=>{
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            preloadedEntryPoints: {
                nativeIssueTableEntryPoint: nativeIssueTableEntryPoint
            }
        }), [
        nativeIssueTableEntryPoint
    ]);
    const ErrorBoundary = (0, $4R6GH.fg)('improve_nin_slo_events') ? (0, $7iJwP.default) : (0, $7CMCs.JSErrorBoundary);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "jira-router-gin-redirect-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
        id: "jira-router-gin-redirect-entrypoint",
        packageName: "jiraRouterIssueNavigatorEntries"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "gin-redirect-entrypoint",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7e6cc6bb050ade$export$fb85bbdbfb3e6869, null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: entryPointProps
    }))));
});
const $1f7e6cc6bb050ade$export$3b4f172f4310bbc = ({ preloadedEntryPoints: preloadedEntryPoints })=>{
    const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, $1kQCU.useGlobalScopeEnrolmentEnable)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    // Regardless of the existing localStorageData value, we update the localStorage value once we get resourceData so
    // that future renders are fast and accurate.
    (0, $5uXOq.useEffect)(()=>{
        if (resourceData !== null && resourceData !== undefined) (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
    }, [
        resourceData
    ]);
    // If NIN in global scope is not enabled then we redirect to legacy GIN by performing a reload
    (0, $5uXOq.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isNinGlobalScopeEnrolmentEnabled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isNinGlobalScopeEnrolmentEnabled) {
            // If we are in global scope nin then reset/enable the forced opt out flag for GIN if we haven't done it already
            const globalGINFlagDisabled = (0, $VILOn.getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
            if (globalGINFlagDisabled !== false) {
                !isAnonymous && (0, $7SHTM.resetGlobalScopeForcedOptOutGinFlag)();
                (0, $VILOn.setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
            }
        }
    }, [
        isAnonymous,
        isNinGlobalScopeEnrolmentEnabled
    ]);
    const entryPointReference = preloadedEntryPoints.globalIssueNavigatorEntryPoint;
    const nativeIssueTableEntryPoint = preloadedEntryPoints.nativeIssueTableEntryPoint;
    // If NIN in global scope is enabled then we render it. If NIN in global scope is not enabled, or we're blocked
    // waiting on the resource to load then we render GlobalIssueNavigatorSkeleton.
    return isNinGlobalScopeEnrolmentEnabled === true && entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7e6cc6bb050ade$var$GlobalIssueNavigatorEntryPointContainer, {
        entryPointReference: entryPointReference,
        nativeIssueTableEntryPoint: nativeIssueTableEntryPoint
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gXMV.GlobalIssueNavigatorSkeleton), null);
};
const $1f7e6cc6bb050ade$export$259dd4583d348d86 = ({ entryPoints: entryPoints })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f7e6cc6bb050ade$export$3b4f172f4310bbc, {
        preloadedEntryPoints: entryPoints
    });
var $1f7e6cc6bb050ade$export$2e2bcd8739ae039 = $1f7e6cc6bb050ade$export$259dd4583d348d86;

});
parcelRegister("1kQCU", function(module, exports) {

$parcel$export(module.exports, "useGlobalScopeOptOutFlow", () => $d96a4352cc61ecaf$export$f39dd0211cb78bcf);
$parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", () => $d96a4352cc61ecaf$export$f45d1a4e873cac44);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $VILOn = parcelRequire("VILOn");

var $7SHTM = parcelRequire("7SHTM");

var $bATyw = parcelRequire("bATyw");

var $bVDE5 = parcelRequire("bVDE5");

var $cZpsT = parcelRequire("cZpsT");

var $2YP9W = parcelRequire("2YP9W");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $aK1ba = parcelRequire("aK1ba");

var $cnynt = parcelRequire("cnynt");
const $d96a4352cc61ecaf$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('', false);
const $d96a4352cc61ecaf$export$f39dd0211cb78bcf = (href)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const redirectToGin = (0, $5uXOq.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(href);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        href
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $aK1ba.default)({
        onClose: redirectToGin,
        isAdminSettingsModal: false
    });
    /**
	 * globalScopeOptOut
	 * Triggers the NIN Global Scope opt-out process, including all UI orchestration of feedback.
	 *
	 * The caller should handle "default" behaviour for when the user is already not enrolled,
	 * unless the `preventDefault` callback has been called. This allows for easy usage with links,
	 * where the onClick event's `preventDefault` can be passed.
	 *
	 * If using an event's `preventDefault`, remember to bind the event!
	 * ex: `globalScopeOptOut(event.preventDefault.bind(event));`
	 *
	 * @param {Function} preventDefault
	 */ return (0, $5uXOq.useCallback)(async (preventDefault)=>{
        // If the user has already opt-out, just allow the caller to handle the click
        if (!(0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
        // Otherwise, take over the interaction
        preventDefault && preventDefault();
        try {
            // Update user preference and local storage
            !isAnonymous && await (0, $7SHTM.setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
            (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
            renderFeedbackDialog();
            if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $d96a4352cc61ecaf$var$sessionStorageProvider.set('showGinOptOutFlag', 'true');
            else sessionStorage.setItem('showGinOptOutFlag', 'true');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cnynt.default).errorOptOutTitleIssueTermRefresh : (0, $cnynt.default).errorOptOutTitle,
                description: (0, $cnynt.default).errorOptOutDesc,
                testId: 'issue-navigator-action-meatball-menu.ui.error-flag',
                messageId: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'optOutOfNin',
                    packageName: 'jiraIssueNavigatorChangeboarding',
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
    }, [
        isAnonymous,
        renderFeedbackDialog,
        showFlag
    ]);
};
const $d96a4352cc61ecaf$export$f45d1a4e873cac44 = ()=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.
    const [localStorageData] = (0, $5uXOq.useState)((0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
    const { data: resourceData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    // We assume NIN global scope is enabled if this is an initial render, otherwise we rely on localStorageData if it
    // exists, otherwise we use resourceData. resourceData is async, and can block for a long time, so we optimise for
    // speed rather than correctness by trusting localStorageData.
    let isNinGlobalScopeEnrolmentEnabled;
    if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
    else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = resourceData;
    return [
        isNinGlobalScopeEnrolmentEnabled,
        resourceData
    ];
};

});
parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("7SHTM", function(module, exports) {

$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", () => $a1fa570fc83fd392$export$2fc59b10f256dbee);
$parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", () => $a1fa570fc83fd392$export$89f09c81b642e3c7);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $a1fa570fc83fd392$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0]
    });
};
const $a1fa570fc83fd392$export$2fc59b10f256dbee = async (value)=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment',
        value: value ? 'nin' : 'gin'
    });
const $a1fa570fc83fd392$export$89f09c81b642e3c7 = async ()=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
        value: false
    }).catch((error)=>(0, $jcw0u.default)({
            meta: {
                id: 'resetGlobalScopeGinFlag',
                packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        }));

});

parcelRegister("aK1ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $106d1fc5065910b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $bw7Gm = parcelRequire("bw7Gm");

var $4DPZY = parcelRequire("4DPZY");

var $9OXo1 = parcelRequire("9OXo1");

var $g7SDw = parcelRequire("g7SDw");
const $106d1fc5065910b3$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
const $106d1fc5065910b3$var$unknownAttributeValue = 'unknown';
const $106d1fc5065910b3$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
        {
            id: (0, $7iULw.EntryKeys).LOCATION,
            value: (0, $bw7Gm.default)(globalThis.location?.href)
        },
        {
            id: (0, $7iULw.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $bw7Gm.default)(document.referrer) : ''
        },
        {
            id: (0, $7iULw.EntryKeys).USER_AGENT,
            value: globalThis.navigator?.userAgent
        },
        {
            id: (0, $7iULw.EntryKeys).SCREEN_RESOLUTION,
            value: `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}`
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
            value: routeGroup
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: isProjectSimplified.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $106d1fc5065910b3$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const titleDetails = isAdminSettingsModal ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).titleDetailsAdminIssueTermRefresh : (0, $g7SDw.default).titleDetailsAdmin) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).titleDetailsUserIssueTermRefresh : (0, $g7SDw.default).titleDetailsUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, titleDetails));
};
const $106d1fc5065910b3$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const routeGroup = route.group ?? $106d1fc5065910b3$var$unknownAttributeValue;
    const routeName = route.name ?? $106d1fc5065910b3$var$unknownAttributeValue;
    let projectType = $106d1fc5065910b3$var$unknownAttributeValue;
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) {
        projectType = projectData.project.type;
        isProjectSimplified = projectData.project.isSimplified;
    }
    const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: $106d1fc5065910b3$export$3fe286306fb8ddfb,
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
            onClose: onClose,
            feedbackContext: $106d1fc5065910b3$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeGroup: routeGroup,
                routeName: routeName,
                projectType: projectType,
                isProjectSimplified: isProjectSimplified
            }),
            feedbackTitle: formatMessage((0, $g7SDw.default).title),
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($106d1fc5065910b3$export$3a73a4e2115ebf73, {
                isAdminSettingsModal: isAdminSettingsModal
            }),
            selectLabel: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).reasonTitleIssueTermRefresh : (0, $g7SDw.default).reasonTitle),
            // Intentional whitespace to clear the placeholder
            // (eluding feedback dialog's empty check for this prop, which includes empty string)
            summaryPlaceholder: ' ',
            submitButtonLabel: formatMessage((0, $g7SDw.default).submitCaption),
            cancelButtonLabel: formatMessage((0, $g7SDw.default).cancelCaption),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonSpeed)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonParity)
                }
            }
        });
    }, [
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeGroup,
        routeName,
        projectType,
        isProjectSimplified,
        formatMessage,
        isAdminSettingsModal
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};
var $106d1fc5065910b3$export$2e2bcd8739ae039 = $106d1fc5065910b3$var$useFeedbackDialog;
const $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("g7SDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa18157d389278a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5fa18157d389278a$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
        "defaultMessage": "Let us know why you're moving"
    },
    titleDetailsAdmin: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUser: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    submitCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
        "defaultMessage": "Send feedback"
    },
    cancelCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
        "defaultMessage": "Skip"
    },
    reasonTitle: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    },
    reasonPlaceholder: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonParity: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
        "defaultMessage": "Features are missing"
    },
    reasonSpeed: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
        "defaultMessage": "It's slow"
    },
    reasonBug: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
        "defaultMessage": "There's a bug"
    },
    reasonOthers: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
        "defaultMessage": "Others"
    },
    reasonQuestion: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
        "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
    },
    titleDetailsAdminIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    titleDetailsUserIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    reasonTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
        "defaultMessage": "What's the reason you're going back to the old way to searching for work items?"
    }
});
var $5fa18157d389278a$export$2e2bcd8739ae039 = $5fa18157d389278a$var$messages;

});


parcelRegister("cnynt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37d0c1deb4d01ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c37d0c1deb4d01ea$var$messages = (0, $7VHMR.defineMessages)({
    errorOptOutTitle: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
        "defaultMessage": "We couldn't switch to the old issue search"
    },
    errorOptOutDesc: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
        "defaultMessage": "Refresh and try again."
    },
    errorOptOutTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
        "defaultMessage": "We couldn't switch to the old search"
    }
});
var $c37d0c1deb4d01ea$export$2e2bcd8739ae039 = $c37d0c1deb4d01ea$var$messages;

});




//# sourceMappingURL=async-global-issue-navigator-gin-redirect-entrypoint.975b3860.js.map
